import { render, staticRenderFns } from "./SolarIcon.vue?vue&type=template&id=7dd345e2&scoped=true"
import script from "./SolarIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SolarIcon.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SolarIcon.vue?vue&type=style&index=0&id=7dd345e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd345e2",
  null
  
)

export default component.exports